import HttpClient, { emptyPageListResponse } from "../../../core/api/httpClient";
import { queryBuilder } from "../../../core/api/queryBuilder";
import { PagedList } from "../../../core/api/pagedList";
import { InstructionalVideoWatchLogDto, InstructionalVideoWatchStatisticsDto } from "../model/watchLogDto";


const baseUrl = "/api/watch-logs"
const statisticsListUrl = "/api/watch-logs/statistics"

export default class WatchLogApi {
    static async getList(odataQueryParameters?: string): Promise<PagedList<InstructionalVideoWatchLogDto>> {
        try {
            const defaultQueryParameters = queryBuilder.pagination(1, 25)
            const url = `${baseUrl}${odataQueryParameters ? `?${odataQueryParameters}` : `${defaultQueryParameters}` }`
            const response = await HttpClient.get(url)
            if (response.ok) {
                return await response.json()
            } else {
                return emptyPageListResponse(25)
            }
        } catch (error) {
            return emptyPageListResponse()
        }
    }

    static async getStatisticsList(odataQueryParameters?: string): Promise<PagedList<InstructionalVideoWatchStatisticsDto>> {
        try {
            const defaultQueryParameters = queryBuilder.pagination(1, 25)
            const url = `${statisticsListUrl}${odataQueryParameters ? `?${odataQueryParameters}` : `${defaultQueryParameters}` }`
            const response = await HttpClient.get(url)
            if (response.ok) {
                return await response.json()
            } else {
                return emptyPageListResponse()
            }

        } catch(error) {
            return emptyPageListResponse()
        }
    }
}
